module.exports = __webpack_public_path__ + "static/media/sign-out.16ef72b4.svg";